import { useEffect, useContext, useRef } from 'react';

// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// redux
import { useDispatch } from './redux/store';
import useAuth from './hooks/useAuth';

// components
import RtlLayout from './components/RtlLayout';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import ThemeColorPresets from './components/ThemeColorPresets';
import ThemeLocalization from './components/ThemeLocalization';
import MotionLazyContainer from './components/animate/MotionLazyContainer';

// utils
import { OnConnectCompany } from './utils/socketControl';
import { SocketContext } from './contexts/SocketIo';

import { updateContactRealTime, deleteContactRealTime } from './redux/slices/chat'; // reducers novos

// ----------------------------------------------------------------------

export default function App() {
  const { user, update } = useAuth();
  const dispatch = useDispatch();
  const socket = useContext(SocketContext);
  const handlerRef = useRef(null);
  const channelRef = useRef(null);

  useEffect(() => {
    // Read socket msg in all application
    if (!user || !socket) return undefined;

    // Limpa handler anterior se o canal mudar ou o user mudar
    if (handlerRef.current && channelRef.current) {
      socket.off(channelRef.current, handlerRef.current);
    }

    const handler = (msg) => {
      const messageType = msg.metadata?.type || msg.type;

      if (messageType === 'contactUpdate') {
        dispatch(updateContactRealTime(msg.data));
      }

      if (messageType === 'contactDelete') {
        dispatch(deleteContactRealTime(msg.data));
      }

      OnConnectCompany(msg, user, dispatch, update);
    };

    handlerRef.current = handler;
    channelRef.current = user.companyId;

    socket.on(user.companyId, handler);

    return () => {
      socket.off(user.companyId, handler);
    };
  }, [dispatch, user, socket, update]);

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <ThemeLocalization>
          <RtlLayout>
            <NotistackProvider>
              <MotionLazyContainer>
                <ProgressBarStyle />
                <ChartStyle />
                <ScrollToTop />
                <Router />
              </MotionLazyContainer>
            </NotistackProvider>
          </RtlLayout>
        </ThemeLocalization>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
